// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"0acb19a8","293":"0d08b544","488":"774a843c","625":"f8d4e76b","658":"f2d9d93a","735":"27319e59","748":"fa44ac37","785":"76965105"}[chunkId] + ".js";
};